// extracted by mini-css-extract-plugin
export default {"containprod":"GI","containprod2":"HI","simple":"II","editablecontain":"JI","reverse":"KI"};
    if(module.hot) {
      // 1711394578747
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  